import { render, staticRenderFns } from "./SchoolYear.vue?vue&type=template&id=4349e3ad&scoped=true"
import script from "./SchoolYear.vue?vue&type=script&lang=js"
export * from "./SchoolYear.vue?vue&type=script&lang=js"
import style0 from "./SchoolYear.vue?vue&type=style&index=0&id=4349e3ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4349e3ad",
  null
  
)

export default component.exports